import Lightbox from 'yet-another-react-lightbox'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import Counter from 'yet-another-react-lightbox/plugins/counter'
import Download from 'yet-another-react-lightbox/plugins/download'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import 'yet-another-react-lightbox/plugins/counter.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

export default function EvidenceLightbox({ open, index = 0, images = [], onClose }) {
  const slides = images.map((image, imageIndex) => ({
    src: image.src,
    description: image.title || 'Comprobante',
    download: {
      url: image.downloadUrl || image.src,
      filename: image.filename || `comprobante-${imageIndex + 1}`
    }
  }))

  return (
    <Lightbox
      open={open}
      close={onClose}
      index={index}
      plugins={[Captions, Counter, Thumbnails, Zoom, Download]}
      animation={{ swipe: 0 }}
      counter={{ container: { style: { top: 16, left: 16 } } }}
      thumbnails={{
        position: 'bottom',
        width: 72,
        height: 72,
        border: 0,
        borderRadius: 8,
        padding: 4,
        gap: 8
      }}
      zoom={{ scrollToZoom: true }}
      slides={slides}
      styles={{
        container: { backgroundColor: 'rgba(0, 0, 0, .82)' },
        captionsDescriptionContainer: {
          display: 'flex',
          justifyContent: 'center'
        }
      }}
    />
  )
}
